<template>
  <div>
    <div class="navigationWrapper">
      <div class="navigation">
        <div class="breadcrumb">
          选择你的行业
        </div>
        <h2>
          选择你的行业
        </h2>
      </div>
    </div>
    <div class="ceMetaIndustrySelect">
        <div v-for="(item,index) in IndustryList" :key="index">
          <div class="industryPanel">
              <div class="industryPanelTitle">
                  <div class="industryPanelTitleName">小红书</div>
              </div>
              <div class="industryNamePanel">
                  {{item.name}}
              </div>
              <div class="industryItemDescPanel">
                  {{item.desc}}
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
      return {
        IndustryList:[
            {
                name:"家电行业",
                desc:"Create compelling product descriptions for Amazon. We have a team of experts who can help you create a product description that will help you sell more on Amazon.Create compelling product descriptions for Amazon. We have a team of experts who can help you create a product description that will help you sell more on Amazon.",
                tag: "HomeAppliances"
            },
            {
                name:"汽车行业",
                desc:"Create compelling product descriptions for Amazon. We have a team of experts who can help you create a product description that will help you sell more on Amazon.",
                tag: "Automobile"
            },
            {
                name:"美妆行业",
                desc:"Create compelling product descriptions for Amazon. We have a team of experts who can help you create a product description that will help you sell more on Amazon.",
                tag: "Cosmetics"
            },
            {
                name:"快消行业",
                desc:"Create compelling product descriptions for Amazon. We have a team of experts who can help you create a product description that will help you sell more on Amazon.",
                tag: "FastMovingConsumerGoods"
            }
        ]
      }
    }
}
</script>

<style lang="less" scoped>
.ceMetaIndustryWrapper {
    background-color: #f6fafe;
}
.ceMetaIndustrySelect {
    width: 1280px;
    margin: 0 auto;
    background-color: #FFFFFF;
    padding: 2rem;
    border-radius: 6px;
    box-shadow: 4px 6px 6px 0px rgba(220,220,220,0.08);
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .industryPanel {
        margin: 0.5rem 0.5rem 0.5rem 0.5rem;
        border-radius: 12px;
        border: rgb(229,231,235) solid 1px;
        padding: 12px;
        width: 18rem;
        display: flex;
        flex-direction: column;

        .industryPanelTitle {
            margin: 0.5rem 0 1rem 0.5rem;
            .industryPanelTitleName {
                height: 4rem;
                width: 4rem;
                border-radius: 50%;
                background-color: red;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #FFFFFF;
            }
        }

        .industryNamePanel {
            font-size: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 6rem;
            font-weight: 500;
        }

        .industryItemDescPanel {
            height: 10rem;
            font-size: 19px;
            padding: 0 10px 0 10px;
            color: rgb(109,114,127);
            font-weight: 300;
            overflow: hidden; 
        }
    }
}

.navigationWrapper {
	border-bottom: 1px solid #DEDEDE;
	margin-bottom: 38px;
}

.navigation {
	width: 1280px;
	margin: 0 auto;
	.breadcrumb {
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		margin: 20px 0;

		span {
			padding: 0 8px;
		}
	}

	h2 {
		font-size: 36px;
		font-weight: 500;
		color: #333333;
	}
}
</style>


// WEBPACK FOOTER //
// src/views/industrySelect/index.vue